import { keys, sortBy } from 'lodash';
import moment from 'moment';
import '../../utils/moment-extensions';

/**
 * @param {object} doctorLocation
 */
export default function recalculateNextAppointment(doctorLocation) {
    const orderedDates = getOrderedDates(doctorLocation);

    convertNextAppointmentToMoment(orderedDates);
    fillNextAppointmentForDatesWithAppointments(orderedDates);
    fillNextAppointmentForDatesWithoutAppointments(orderedDates);
    ensureAllNextAppointmentsAreAccurate(orderedDates);
}

function getOrderedDates(doctorLocation) {
    const dateKeys = keys(doctorLocation);
    const orderedDateKeys = sortBy(dateKeys, dateKey => dateKey);
    const orderedDates = [];

    orderedDateKeys.forEach(dateKey => orderedDates.push(doctorLocation[dateKey]));

    return orderedDates;
}

function convertNextAppointmentToMoment(orderedDates) {
    orderedDates.forEach(date => {
        if (date.nextAppointment) {
            date.nextAppointment = moment(date.nextAppointment);
        }
    });
}

function fillNextAppointmentForDatesWithAppointments(orderedDates) {
    for (let i = 0; i < orderedDates.length; i++) {
        const date = orderedDates[i];

        if (date.appointments.length > 0) {
            date.nextAppointment = moment(date.appointments[0].date);
        }
    }
}

function fillNextAppointmentForDatesWithoutAppointments(orderedDates) {
    let otherDate;

    for (let i = 0; i < orderedDates.length; i++) {
        const date = orderedDates[i];

        if (!date.nextAppointment) {
            for (let j = 0; j < orderedDates.length; j++) {
                otherDate = orderedDates[j];

                if (otherDate.nextAppointment && otherDate.nextAppointment.dayDiff(date.date) > 0) {
                    date.nextAppointment = otherDate.nextAppointment;
                    break;
                }
            }
        }
    }
}

function ensureAllNextAppointmentsAreAccurate(orderedDates) {
    let nextKnownAppt;

    for (let i = orderedDates.length - 1; i >= 0; i--) {
        const date = orderedDates[i];

        if (date.appointments.length > 0) {
            nextKnownAppt = moment(date.appointments[0].date);
        } else if (date.nextAppointment && nextKnownAppt) {
            // If the date's currently computed next appointment is later than
            // the next appointment time we know about, correct it
            if (date.nextAppointment.dayDiff(nextKnownAppt) > 0) {
                date.nextAppointment = nextKnownAppt;
            }
        }
    }
}
